import React from 'react';

interface IYoutubeVideo {
    isError: boolean,
    title?: string,
    src?: string,
    error?: string,
    classes?: string;
}

const YoutubeVideo = (props: IYoutubeVideo) => {

    const { title, src, error, isError } = props;

    return (
        <>
            { isError && error && <div dangerouslySetInnerHTML={{ __html: error }} /> }

            {
                !isError &&
                <div className={`waves-video ${ props.classes  || ''}`}>
                    <iframe src={ src } title={ title } className={`absolute inset-0 w-full h-full`}></iframe>
                </div>
            }
        </>
    )
};

export default YoutubeVideo;